export var LOG_PREFIX = 'storage:localstorage: ';
export var DEFINED = '1';
